import CallToAction from "@/components/Button";
import { SVGArrowRight } from "@/lib/svg";
import { forwardRef } from "react";
import styled from "styled-components";
import { ImageWrapper as _ImageWrapper } from "@/lib/styles/theme";
import { H2, P } from "@/lib/styles";

export const Container = styled.div<{ $imagePosition?: string, $textPresent?: boolean }>`
  margin-bottom: 0;
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: wrap;

  ${({ theme }) => theme.mediaQueries.laptop} {
    flex-direction: ${({ $imagePosition }) => $imagePosition?.includes("right") ? "row-reverse" : "row"};
    flex-wrap: nowrap;
    justify-content: ${({ $textPresent, $imagePosition }) => $textPresent ? "space-between" : ($imagePosition?.includes("center") ? "center" : "space-between")};
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  margin-top: 0;
  display: flex;
  justify-content: center;
  align-items: baseline;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.tablet} {
    width: calc(100% - 3rem);
    padding: 0 1.5rem;
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    width: calc(50% - 1.5rem);
  }
`;

export const Excerpt = styled(P)`
  background-color: ${({ theme }) => theme.colors.white};
  opacity: 0;
  padding: 0.5rem 0;
  margin-bottom: 2.5rem;

  .lines {
    opacity: 0;
    transform: translateY(20px);
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    padding: 0.5rem 0;
  }
`;

export const Heading = styled(H2)`
  margin-bottom: 1.5rem;
  opacity: 0;
  padding: 0.5rem 0;

  .lines {
    opacity: 0;
    transform: translateY(20px);
  }
`;

const _Button = forwardRef<
  HTMLAnchorElement,
  { children: string; href?: string; target?: string }
>((props, ref) => (
  <CallToAction
    ref={ref}
    as="a"
    variant="primaryUnboxed"
    icon={<SVGArrowRight />}
    {...props}
  />
));

_Button.displayName = "_Button";

export const Button = styled(_Button)`
  width: fit-content;
  opacity: 0;
  transform: translateY(20px);

  &:not(:last-child) {
    margin-bottom: 1rem; // This covers a design exception
  }
`;

export const ButtonsContainer = styled.div`
  align-self: start;
`;
